import { ScheduleAPIResponse } from '../ScheduleAPI.model';

function getWeekDaysNotEmpty(schedule: ScheduleAPIResponse['schedule']) {
  return Object.entries(schedule ?? {}).filter(
    ([weekDay, list]) => list && list.length > 0
  );
}

export default getWeekDaysNotEmpty;
